<div class="flex flex-col items-center justify-center gap-8 p-8">
    <h2 class="text-center">Welcome to Police Station Kiosk Administration</h2>
    <button mat-flat-button color="primary" class="px-8 py-2" (click)="login()">Login</button>
</div>
<div *ngIf="isLoading" class="fixed top-center left-center">
    <mat-spinner></mat-spinner>
</div>
